// extracted by mini-css-extract-plugin
export default {"networkIcon":"styles_networkIcon__mALq+","networkIconWhiteStyle":"styles_networkIconWhiteStyle__Wvi4W"};